import { render, staticRenderFns } from "./MeinServiceErstellen.vue?vue&type=template&id=274ad79c&scoped=true&"
import script from "./MeinServiceErstellen.vue?vue&type=script&lang=js&"
export * from "./MeinServiceErstellen.vue?vue&type=script&lang=js&"
import style0 from "./MeinServiceErstellen.vue?vue&type=style&index=0&id=274ad79c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ad79c",
  null
  
)

export default component.exports